import { t } from "i18next";
import { getPersonSchema } from "@/services/api/entities/person/constants/person-schema";

const personSchema = getPersonSchema();

export const personInfoSchema = personSchema
  .pick([
    "firstName",
    "middleName",
    "lastName",
    "gender",
    "birthday",
    "additionalInformation",
    "group",
    "title",
  ])
  .test(
    "at-least-one-name",
    () => t("validation.required"),
    function (value) {
      const hasAtLeastOneName =
        Boolean(value.firstName) || Boolean(value.title) || Boolean(value.lastName);

      if (!hasAtLeastOneName) {
        return this.createError({
          path: "firstName",
          message: () => t("validation.required"),
        });
      }

      return true;
    },
  )
  .test(
    "at-least-one-name-2",
    () => t("validation.required"),
    function (value) {
      const hasAtLeastOneName =
        Boolean(value.firstName) || Boolean(value.title) || Boolean(value.lastName);

      if (!hasAtLeastOneName) {
        return this.createError({
          path: "title",
          message: () => t("validation.required"),
        });
      }

      return true;
    },
  )
  .test(
    "at-least-one-name-3",
    () => t("validation.required"),
    function (value) {
      const hasAtLeastOneName =
        Boolean(value.firstName) || Boolean(value.title) || Boolean(value.lastName);

      if (!hasAtLeastOneName) {
        return this.createError({
          path: "lastName",
          message: () => t("validation.required"),
        });
      }

      return true;
    },
  );
